// GENERADO desde public/user-manual.pdf (texto idéntico). No editar a mano el
// contenido acá sin actualizar también el PDF descargable.

export interface ItemLista {
	texto: string;
	sub?: string[];
}

export interface Bloque {
	tipo: 'p' | 'ul' | 'ol';
	texto?: string;
	items?: ItemLista[];
}

export interface Pregunta {
	id: string;
	numero: string;
	titulo: string;
	bloques: Bloque[];
}

export interface Seccion {
	id: string;
	numero: string;
	titulo: string;
	intro: Bloque[];
	preguntas: Pregunta[];
}

export const MANUAL_ACTUALIZADO = '27/08/2025';

export const MANUAL: Seccion[] = [
	{
		"id": "s1",
		"numero": "1",
		"titulo": "¿Qué es cambiapp?",
		"intro": [
			{
				"tipo": "p",
				"texto": "cambiapp es la primera plataforma de compraventa de divisas físicas entre particulares."
			},
			{
				"tipo": "p",
				"texto": "En www.cambiapp.net podrás comprar o vender dólares, euros o reales brasileños a otros usuarios, de manera simple, segura y con las mejores cotizaciones."
			},
			{
				"tipo": "p",
				"texto": "Operar es sencillo:"
			},
			{
				"tipo": "p",
				"texto": "1º Ingresas al panel de compras o al de ventas, según la operación que quieras hacer."
			},
			{
				"tipo": "p",
				"texto": "2º Verificás si existe alguna publicación hecha por otro usuario que sea de tu interés."
			},
			{
				"tipo": "p",
				"texto": "En caso contrario creas tu propia publicación de compra o de venta, indicando cantidad, condiciones y posibles citas de transacción."
			},
			{
				"tipo": "p",
				"texto": "3º Aceptás la publicación de otro usuario, o bien otro usuario acepta tu publicación."
			},
			{
				"tipo": "p",
				"texto": "Esa aceptación deja a la operación confirmada, con cita de transacción determinada."
			},
			{
				"tipo": "p",
				"texto": "4º La operación se concreta físicamente en nuestra Oficina, el día y hora elegidos, con asesoramiento y asistencia del Administrador."
			},
			{
				"tipo": "p",
				"texto": "cambiapp es una comunidad cerrada y confidencial."
			},
			{
				"tipo": "p",
				"texto": "El registro para creación de tu cuenta funciona como solicitud y requiere aprobación del Administrador, quien puede aplicar verificaciones razonables (identidad, antecedentes, capacidad legal, domicilio y datos de contacto) y aceptar o rechazar el alta."
			},
			{
				"tipo": "p",
				"texto": "En cambiapp podés operar con la tranquilidad de que todos los miembros de la comunidad fueron previamente verificados por el Administrador, lo que asegura que conocemos con quién estás tratando."
			},
			{
				"tipo": "p",
				"texto": "Además, cada operación se concreta en la Oficina con control de autenticidad e integridad de los billetes, brindándote respaldo y seguridad en todo momento."
			},
			{
				"tipo": "p",
				"texto": "Nobile Capital S.R.L. desarrolla su operatoria bajo la marca cambiapp de acuerdo con la normativa vigente en la República Argentina, contando con todas las inscripciones y habilitaciones necesarias a tal efecto, y ajustando sus procesos internos a los requisitos legales aplicables para garantizar validez y seguridad jurídica en sus servicios como plataforma digital."
			}
		],
		"preguntas": []
	},
	{
		"id": "s2",
		"numero": "2",
		"titulo": "Cómo vender",
		"intro": [],
		"preguntas": [
			{
				"id": "2-1",
				"numero": "2.1",
				"titulo": "¿Cómo vendo mis divisas?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "En la pantalla de inicio, seleccioná “VENDER DIVISAS” para ingresar a tu Panel de Ventas."
					},
					{
						"tipo": "p",
						"texto": "Luego seleccioná con cuál divisa queres operar (dólares, euros o reales) Desde allí podrás vender por dos vías alternativas:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Vía directa: crear tu propia publicación de venta, que podrá ser aceptada por otro usuario."
							},
							{
								"texto": "Vía inversa: aceptar la publicación de compra que haya hecho otro usuario."
							}
						]
					}
				]
			},
			{
				"id": "2-2",
				"numero": "2.2",
				"titulo": "¿Cómo creo mi publicación de venta?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "En tu Panel de Ventas, y ya habiendo seleccionado con qué divisa querés operar, tocá el botón inferior: “NUEVA PUBLICACIÓN DE VENTA”."
					},
					{
						"tipo": "p",
						"texto": "Deberás completar un formulario con:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Cantidad total que querés vender."
							},
							{
								"texto": "Denominación, versión y estado de los billetes."
							},
							{
								"texto": "Precio unitario en pesos."
							},
							{
								"texto": "Citas de transacción posibles para concretar la operación en la Oficina."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "Una vez publicada, la oferta aparecerá como una cápsula en el área Publicaciones Vigentes de tu Panel de Ventas, y también se mostrará en los Paneles de Compras de los demás usuarios."
					}
				]
			},
			{
				"id": "2-3",
				"numero": "2.3",
				"titulo": "¿Qué cantidad puedo vender?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La cantidad mínima de una publicación, dependiendo de cuál sea la divisa, es de:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "USD 100"
							},
							{
								"texto": "EUR 100"
							},
							{
								"texto": "BRL 500"
							}
						]
					},
					{
						"tipo": "p",
						"texto": "No hay límite de cantidad máxima, salvo por los dígitos que permita el pertinente campo del sistema."
					},
					{
						"tipo": "p",
						"texto": "Además, cuando creas tu publicación podés habilitar la opción “Permitir aceptación parcial”, que le da al comprador la posibilidad de adquirir solo una parte de la misma."
					}
				]
			},
			{
				"id": "2-4",
				"numero": "2.4",
				"titulo": "¿Puedo incluir en una sola publicación billetes de diferente denominación, versión y estado?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Cada publicación puede incluir hasta 2 lotes diferentes de billetes, con distinta combinación de denominación, versión y estado."
					},
					{
						"tipo": "p",
						"texto": "Ejemplo: podés publicar un total de USD 1.300, compuesto por un lote de USD 1.000 en billetes de cien, versión nueva, impecables, y otro lote de USD 300 en billetes de cincuenta, versión anterior, con detalles."
					},
					{
						"tipo": "p",
						"texto": "Para mayor claridad comercial, se recomienda que las publicaciones sean lo más homogéneas posibles. Por lo tanto, si los lotes son muy heterogéneos, aconsejamos hacer varias publicaciones diferentes que comprendan a cada uno de ellos."
					}
				]
			},
			{
				"id": "2-5",
				"numero": "2.5",
				"titulo": "¿Al concretarse la venta, puedo entregar billetes en mejores condiciones que las especificadas en mi publicación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Las condiciones de denominación, versión y estado que consignes en tu publicación se consideran mínimas."
					},
					{
						"tipo": "p",
						"texto": "Esto significa que podés entregar billetes de mayor denominación, versión más nueva o mejor estado, en cualquier proporción."
					},
					{
						"tipo": "p",
						"texto": "Ejemplo: si publicaste billetes de cincuenta, versión anterior, con detalles, podés entregar billetes de cien, versión nueva, impecables."
					},
					{
						"tipo": "p",
						"texto": "La única excepción es cuando para completar el monto publicado debés incluir billetes de menor denominación. Por ejemplo, si publicaste un lote de USD 1.345, indicando que la denominación mínima es de cien, al momento de concretar la operación, podés entregar: 13 billetes de cien, 2 billetes de veinte, y 1 billete de cinco."
					}
				]
			},
			{
				"id": "2-6",
				"numero": "2.6",
				"titulo": "¿A qué precio puedo vender mis divisas?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "El precio unitario en pesos es un dato obligatorio que debe indicarse en toda publicación de venta. Luego el sistema calculará automáticamente el precio total de la publicación."
					},
					{
						"tipo": "p",
						"texto": "Podes consignar el precio que quieras sin restricciones, ya que cambiapp no fija mínimos ni máximos de precio. No obstante, te recomendamos tomar como referencia las cotizaciones de mercado libre o “blue”, y considerar además la versión y estado de los billetes."
					},
					{
						"tipo": "p",
						"texto": "Si la publicación tiene más de un lote, deberás establecer un precio promedio único para todos ellos."
					}
				]
			},
			{
				"id": "2-7",
				"numero": "2.7",
				"titulo": "¿Puedo requerir que el comprador me pague con billetes pesos de determinada denominación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Al crear tu publicación de venta, el sistema te pedirá indicar la denominación mínima de los billetes en pesos que aceptás como pago."
					},
					{
						"tipo": "p",
						"texto": "Ejemplo: si indicás “dos mil”, el comprador podrá pagarte con billetes de dos mil, diez mil, o veinte mil, en cualquier proporción."
					},
					{
						"tipo": "p",
						"texto": "Solo se permiten billetes de menor denominación para completar fracciones menores del precio total, y siempre priorizando los de mayor denominación posible."
					}
				]
			},
			{
				"id": "2-8",
				"numero": "2.8",
				"titulo": "¿Cómo hago para vender por vía inversa?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La vía inversa consiste en aceptar una publicación de compra hecha por otro usuario."
					},
					{
						"tipo": "p",
						"texto": "En tu Panel de Ventas, además de tus publicaciones de ventas, verás las publicaciones de compra creadas por otros usuarios."
					},
					{
						"tipo": "p",
						"texto": "Si alguna de ellas se adapta a las condiciones comerciales que deseas, simplemente la aceptás abriéndola y dándole al botón VENDER. A continuación, elegís una de las citas de transacción contempladas en la publicación, y confirmás la operación."
					},
					{
						"tipo": "p",
						"texto": "Si la publicación permite aceptación parcial, podés vender solo una parte del total demandado."
					}
				]
			}
		]
	},
	{
		"id": "s3",
		"numero": "3",
		"titulo": "Cómo comprar",
		"intro": [],
		"preguntas": [
			{
				"id": "3-1",
				"numero": "3.1",
				"titulo": "¿Cómo compro divisas?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "En la pantalla de inicio, seleccioná “COMPRAR DIVISAS” para ingresar a tu Panel de Compras."
					},
					{
						"tipo": "p",
						"texto": "Luego elegí con qué divisa querés operar (dólares, euros o reales)."
					},
					{
						"tipo": "p",
						"texto": "Desde allí podés comprar de dos maneras alternativas:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Vía directa: crear tu propia publicación de compra, que luego podrá ser aceptada por un vendedor."
							},
							{
								"texto": "Vía inversa: aceptar la publicación de venta que haya hecho otro usuario."
							}
						]
					}
				]
			},
			{
				"id": "3-2",
				"numero": "3.2",
				"titulo": "¿Cómo creo mi publicación de compra?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "En tu Panel de Compras, y ya habiendo seleccionado la divisa, tocá el botón inferior “NUEVA PUBLICACIÓN DE COMPRA”."
					},
					{
						"tipo": "p",
						"texto": "Deberás completar un formulario con:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Cantidad total que querés comprar."
							},
							{
								"texto": "Denominación, versión y estado de los billetes."
							},
							{
								"texto": "Precio unitario en pesos."
							},
							{
								"texto": "Citas de transacción posibles para concretar la operación en la Oficina."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "Una vez publicada, tu demanda aparecerá como una cápsula en el área Publicaciones Vigentes de tu Panel de Compras, y también se mostrará en los Paneles de Ventas de los demás usuarios."
					}
				]
			},
			{
				"id": "3-3",
				"numero": "3.3",
				"titulo": "¿Qué cantidad puedo comprar?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La cantidad mínima de una publicación de compra, dependiendo de cuál sea la divisa, es de:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "USD 100"
							},
							{
								"texto": "EUR 100"
							},
							{
								"texto": "BRL 500"
							}
						]
					},
					{
						"tipo": "p",
						"texto": "No hay límite de cantidad máxima, salvo por los dígitos que permita el pertinente campo del sistema."
					},
					{
						"tipo": "p",
						"texto": "Al crear tu publicación podés habilitar la opción “Permitir aceptación parcial”, lo que le permite al vendedor confirmar solo una parte de cantidad total publicada."
					}
				]
			},
			{
				"id": "3-4",
				"numero": "3.4",
				"titulo": "¿Puedo incluir en una sola publicación de compra billetes de diferente denominación, versión y estado?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "No. Las publicaciones de compra admiten un solo lote de billetes, de determinada denominación, versión y estado."
					}
				]
			},
			{
				"id": "3-5",
				"numero": "3.5",
				"titulo": "¿Al concretarse la compra, puedo recibir billetes en mejores condiciones que los especificados en mi publicación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Las condiciones que indiques en tu publicación se consideran mínimas."
					},
					{
						"tipo": "p",
						"texto": "Esto significa que podés recibir billetes de mayor denominación, versión más nueva o en mejor estado que los solicitados, en cualquier proporción."
					},
					{
						"tipo": "p",
						"texto": "Ejemplo: si publicaste que querés comprar billetes de cincuenta, versión anterior, con detalles, el vendedor podrá venderte billetes de cien, versión nueva, impecables."
					}
				]
			},
			{
				"id": "3-6",
				"numero": "3.6",
				"titulo": "¿A qué precio puedo comprar mis divisas?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "El precio unitario en pesos es un dato obligatorio que debe indicarse en toda publicación de compra. Luego el sistema calculará automáticamente el precio total de la publicación."
					},
					{
						"tipo": "p",
						"texto": "Podes consignar el precio que quieras sin restricciones, ya que cambiapp no fija mínimos ni máximos de precio. No obstante, te recomendamos tomar como referencia las cotizaciones de mercado libre o “blue”, y considerar además la versión y estado de los billetes."
					}
				]
			},
			{
				"id": "3-7",
				"numero": "3.7",
				"titulo": "¿Debo indicar con qué billetes en pesos voy a pagar?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Al crear tu publicación de compra, el sistema te pedirá que indiques la denominación mínima de los billetes pesos con los que cancelarás la operación."
					},
					{
						"tipo": "p",
						"texto": "Ejemplo: si indicás “dos mil”, significa que podrás pagar con billetes de $2.000, $10.000 o $20.000, en cualquier proporción."
					},
					{
						"tipo": "p",
						"texto": "Sólo se aceptan billetes de menor denominación cuando sean necesarios para completar fracciones menores del precio total, siempre priorizando los de mayor denominación disponibles."
					}
				]
			},
			{
				"id": "3-8",
				"numero": "3.8",
				"titulo": "¿Cómo hago para comprar por vía inversa?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La vía inversa consiste en aceptar una publicación de venta creada por otro usuario."
					},
					{
						"tipo": "p",
						"texto": "En tu Panel de Compras, además de tus propias publicaciones de compras, verás las publicaciones de ventas creadas por otros usuarios."
					},
					{
						"tipo": "p",
						"texto": "Si alguna de ellas se adapta a las condiciones comerciales que deseas, simplemente la aceptás abriéndola y dándole al botón COMPRAR. A continuación, elegís una de las citas de transacción contempladas en la publicación, y confirmás la operación."
					},
					{
						"tipo": "p",
						"texto": "Si esa publicación de venta permite aceptación parcial, podés comprar solo una parte del total ofrecido por el otro usuario."
					}
				]
			}
		]
	},
	{
		"id": "s4",
		"numero": "4",
		"titulo": "Panel de operaciones",
		"intro": [],
		"preguntas": [
			{
				"id": "4-1",
				"numero": "4.1",
				"titulo": "¿Qué es el panel de operaciones?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "El panel de operaciones es la pantalla principal donde podés ver el estado de todas tus publicaciones y operaciones en cambiapp."
					},
					{
						"tipo": "p",
						"texto": "Dependiendo de si ingresaste para vender o comprar, el sistema te ubicará automáticamente en tu Panel de Ventas o en tu Panel de Compras."
					},
					{
						"tipo": "p",
						"texto": "Cada panel se divide en cuatro áreas:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Publicaciones vigentes"
							},
							{
								"texto": "Operaciones confirmadas"
							},
							{
								"texto": "Operaciones concretadas"
							},
							{
								"texto": "Publicaciones y operaciones archivadas"
							}
						]
					}
				]
			},
			{
				"id": "4-2",
				"numero": "4.2",
				"titulo": "¿Qué puedo ver y hacer en mi área de Publicaciones Vigentes?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "En esta área se muestran todas las publicaciones que todavía pueden ser aceptadas."
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "En el Panel de Ventas: verás tus propias publicaciones de venta y las publicaciones de compra de otros usuarios."
							},
							{
								"texto": "En el Panel de Compras: verás tus propias publicaciones de compra y las publicaciones de venta de otros usuarios."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "Desde aquí podés:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Visualizar los detalles de cada publicación."
							},
							{
								"texto": "Aceptar publicaciones de otros usuarios."
							},
							{
								"texto": "Gestionar tus propias publicaciones (pausar, modificar o eliminar)."
							}
						]
					}
				]
			},
			{
				"id": "4-3",
				"numero": "4.3",
				"titulo": "¿Cómo se visualizan las publicaciones vigentes?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Cada publicación vigente se muestra como una cápsula dentro de una lista."
					},
					{
						"tipo": "p",
						"texto": "En cada cápsula cerrada podés ver:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "A la izquierda: Se indica quien es el usuario que la creó: Si aparece “Yo”, es una publicación propia; si aparece un alias, es de otro usuario. Luego se indica la cantidad de divisas comprendidas en la publicación."
							},
							{
								"texto": "En el centro: El símbolo central representa el tipo de publicación: El círculo indica que es una publicación de venta, y rombo que es de compra. Su color indica la versión de los billetes: Azul es nueva, verde es anterior, y rojo es vieja. El número central indica su estado de conservación (1,2,3 o 4)."
							},
							{
								"texto": "A la derecha: Se muestra el precio unitario en pesos. Y en el extremo derecho se mostrará en tiempo real lo que resta para que venza la publicación."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "Si tocás la cápsula esta se abrirá, y podrás ver información ampliada (cantidad exacta por lote, denominación mínima, citas disponibles, etc.), y tomar decisiones sobre la publicación (comprar, vender, pausar, modificar, eliminar)."
					}
				]
			},
			{
				"id": "4-4",
				"numero": "4.4",
				"titulo": "¿Qué significa que una operación está confirmada y como se visualiza?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Una operación queda confirmada cuando un usuario acepta la publicación de otro, habiendo elegido una de las citas de transacción propuestas por su emisor."
					},
					{
						"tipo": "p",
						"texto": "En ese instante la operación pasa del área Publicaciones Vigentes al área Operaciones Confirmadas del Panel de Operaciones."
					},
					{
						"tipo": "p",
						"texto": "Y, a partir de ese momento, ambas partes asumen el compromiso de concurrir a la Oficina en la fecha y hora elegidas."
					},
					{
						"tipo": "p",
						"texto": "Las operaciones confirmadas se muestran como cápsulas cerradas, las que pueden abrirse para ver más detalles o tomar decisiones sobre ellas."
					},
					{
						"tipo": "p",
						"texto": "Cada cápsula incluye:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Los datos básicos de la operación."
							},
							{
								"texto": "La cita de transacción y el tiempo restante hasta dicha cita."
							},
							{
								"texto": "En caso de que se soliciten modificaciones, aparecerá la leyenda “Solicitó cambios”."
							}
						]
					}
				]
			},
			{
				"id": "4-5",
				"numero": "4.5",
				"titulo": "¿Cómo se visualizan las operaciones concretadas?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Cuando comprador y vendedor concurren a la Oficina y la operación se lleva a cabo, el Administrador la marca como concretada."
					},
					{
						"tipo": "p",
						"texto": "Estas operaciones aparecen en tu panel dentro del área “Operaciones concretadas”, como registros horizontales, en formato de lista, indicando que la transacción ya fue realizada."
					}
				]
			},
			{
				"id": "4-6",
				"numero": "4.6",
				"titulo": "¿Qué son las publicaciones y operaciones archivadas, y cómo se muestran?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "En éste área del Panel se almacena el historial de:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Publicaciones vencidas, caducadas o eliminadas, que ya no pueden ser aceptadas."
							},
							{
								"texto": "Operaciones abortadas, es decir, aquellas que fueron confirmadas pero que no llegaron a concretarse."
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "s5",
		"numero": "5",
		"titulo": "Publicaciones",
		"intro": [],
		"preguntas": [
			{
				"id": "5-1",
				"numero": "5.1",
				"titulo": "¿Qué denominaciones y versiones de divisas se pueden publicar?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "En cambiapp solo se operan billetes, no monedas metálicas."
					},
					{
						"tipo": "p",
						"texto": "Las divisas con las que actualmente se puede operar son:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Dólares estadounidenses (USD): denominaciones de 1, 5, 10, 20, 50 y 100. Se distinguen por versiones:",
								"sub": [
									"Nueva (N): última serie emitida. En el caso de USD 100, conocida como “Azul”.",
									"Anterior (A): penúltima serie emitida. Para USD 100, “Cara grande”.",
									"Vieja (V): serie más antigua aceptada. Para USD 100, “Cara chica”."
								]
							},
							{
								"texto": "Euros (EUR): se aceptan todas las denominaciones vigentes desde 2002, sin diferenciar versiones."
							},
							{
								"texto": "Reales brasileños (BRL): se aceptan todas las denominaciones vigentes desde 1994, sin diferenciar versiones."
							}
						]
					}
				]
			},
			{
				"id": "5-2",
				"numero": "5.2",
				"titulo": "¿Cómo se clasifican billetes según su estado?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Cada publicación debe indicar el estado de conservación de los billetes de divisas, clasificado en 4 categorías:"
					},
					{
						"tipo": "ol",
						"items": [
							{
								"texto": "Impecables: perfectos, sin manchas, sellos ni deterioro."
							},
							{
								"texto": "Con detalles: en buen estado general, con leves marcas, dobleces o sellos menores."
							},
							{
								"texto": "Muy manchados/marcados: con suciedad, sellos o rayados más notorios, pero recuperables."
							},
							{
								"texto": "Dañados: rotos, cortados, quemados o con deterioro permanente. El billete debe conservar al menos el 60% de su integridad física y su numeración completa para ser aceptado."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "Para los billetes de pesos argentinos (ARS) no se prevé ninguna clasificación en especial. No obstante, el usuario reconoce que deben estar en buen estado general, pudiendo tener detalles, pero no admitiéndose daños o manchas que dificulten su circulación posterior."
					}
				]
			},
			{
				"id": "5-3",
				"numero": "5.3",
				"titulo": "¿Qué es una cita de transacción y la lista de citas posibles (LCP)?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Cada operación confirmada debe realizarse de manera presencial en la Oficina."
					},
					{
						"tipo": "p",
						"texto": "La cita de transacción es el día y hora asignados para la concreción."
					},
					{
						"tipo": "p",
						"texto": "Cuando creás una publicación, seleccionás una lista de citas posibles (LCP)."
					},
					{
						"tipo": "p",
						"texto": "Podés elegirlas de a una, cargar uno o varios tramos (un día, desde y hasta: por ejemplo, martes de 10 a 12 y de 16 a 19), tocar «Todo el día» al lado de cada día, o «Seleccionar todas». Solo se ofrecen los horarios en que la Oficina atiende y que no están tomados."
					},
					{
						"tipo": "p",
						"texto": "La contraparte elegirá una de esas citas al aceptar tu publicación, quedando fija como compromiso."
					}
				]
			},
			{
				"id": "5-4",
				"numero": "5.4",
				"titulo": "¿Qué es la anticipación mínima requerida (AMR)?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La AMR es el tiempo mínimo que debe existir entre la aceptación de tu publicación y la cita elegida."
					},
					{
						"tipo": "p",
						"texto": "El sistema establece un valor predeterminado de 30 minutos, aunque podés ampliarlo según tus necesidades. Por ejemplo, si vivís en otra localidad distinta a donde se encuentra a 1 hora de la oficina de cambiapp, podrías ampliarla la AMR a 1 hora o más, con el fin de evitar riesgos de incumplimiento."
					}
				]
			},
			{
				"id": "5-5",
				"numero": "5.5",
				"titulo": "¿Cuándo vence mi publicación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La publicación vence cuando se agotan las citas disponibles por el paso del tiempo."
					},
					{
						"tipo": "p",
						"texto": "El vencimiento se calcula en función de la última cita disponible y la AMR definida."
					},
					{
						"tipo": "p",
						"texto": "Cuando vence, la publicación pasa automáticamente al área Archivadas."
					}
				]
			},
			{
				"id": "5-6",
				"numero": "5.6",
				"titulo": "¿Cuándo caduca mi publicación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La publicación caduca cuando las citas incluidas en la LCP de tu publicación, son ocupadas por operaciones confirmadas de otros usuarios."
					},
					{
						"tipo": "p",
						"texto": "Si todas las citas son absorbidas por otras operaciones, tu publicación queda sin efecto y pasa a Archivadas."
					},
					{
						"tipo": "p",
						"texto": "Diferencia entre vencimiento y caducidad:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Vencimiento: la publicación expira por el paso del tiempo (AMR)."
							},
							{
								"texto": "Caducidad: la publicación expira porque se agotaron las citas posibles, al ser reservadas en otras operaciones."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "El efecto es el mismo: la publicación se archiva y ya no puede ser aceptada."
					}
				]
			},
			{
				"id": "5-7",
				"numero": "5.7",
				"titulo": "¿Puedo pausar mi publicación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Podés pausarla en cualquier momento antes de que sea aceptada."
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Mientras está pausada, no será visible para otros usuarios."
							},
							{
								"texto": "El tiempo de vigencia y consumo de citas continúa corriendo normalmente."
							},
							{
								"texto": "Podés reactivarla en cualquier momento."
							}
						]
					}
				]
			},
			{
				"id": "5-8",
				"numero": "5.8",
				"titulo": "¿Puedo negociar la publicación de otro usuario?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "cambiapp no permite que los usuarios entablen entre sí negociaciones directas bajo la modalidad de pujas o contrapropuestas, sino que sólo podrán aceptar íntegramente las condiciones (cantidad, calidad, precio, cita) de una publicación, o no hacerlo."
					},
					{
						"tipo": "p",
						"texto": "Sin embargo, podés negociar de manera “indirecta”, efectuando una publicación propia que sea similar o compatible con la publicación de otro que querés negociar."
					},
					{
						"tipo": "p",
						"texto": "Por ejemplo: Tigre32 creó una publicación de venta de USD 1.500 azules impecables a un precio de $ 1.000. Y vos estas dispuesto a comprarle esa misma cantidad y calidad de dólares, pero a un precio de $ 995. Entonces, tu forma de negociarle a ese usuario es generando una publicación de compra a de USD 1.500 azules impecables a $ 995. Tu publicación será vista por Tigre32, y de esa manera lo estarás invitando a que sea él el que acepte tu publicación, en caso de que esté dispuesto a venderte a menor precio."
					}
				]
			},
			{
				"id": "5-9",
				"numero": "5.9",
				"titulo": "¿Se puede comprar o vender por una cantidad menor a la publicada?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí, siempre y cuando el emisor de la publicación lo permita. Para ello, cuando se carga una publicación de venta o de compra, debe activarse la opción “Permitir aceptación parcial”."
					},
					{
						"tipo": "p",
						"texto": "En tal caso, también se deberá indicar cual es la cantidad parcial mínima que se puede aceptar. Dicha cantidad debe ser igual o mayor a USD 100, EUR 100 o BRL 500, y múltiplo de la denominación de los billetes que se está ofreciendo o demandando."
					},
					{
						"tipo": "p",
						"texto": "Por ejemplo, si creaste una publicación de venta por un total de USD 500, en billetes de cien, podrás habilitar la posibilidad de que los otros usuarios te compren una cantidad menor. Y cuando te pregunte cual es la cantidad parcial mínima permitida podrás consignar: 100, 200, 300 o 400. Es decir, cualquier cantidad que sea mayor a 100 y múltiplo de 100. Si, por ejemplo, consignás que la cantidad mínima es 150, el sistema arrojará error, por no ser múltiplo de 100."
					},
					{
						"tipo": "p",
						"texto": "Una vez efectuada una aceptación parcial, la cantidad de la publicación se modificará automáticamente, quedando actualizada por la cantidad restante. Siguiendo el ejemplo, si la publicación de venta se hizo por un total de USD 500, y un usuario aceptó comprar USD 200, la publicación quedará actualizada y vigente por una cantidad de USD 300."
					},
					{
						"tipo": "p",
						"texto": "Si la cantidad restante es igual o menor a la cantidad parcial mínima permitida, la publicación quedará vigente por dicha cantidad restante, pero ya sin permitir aceptación parcial. Es decir, como una publicación común."
					},
					{
						"tipo": "p",
						"texto": "Debes tener en cuenta que con cada aceptación parcial se van consumiendo tus citas disponibles. Y que una vez consumidas todas las citas, aun cuando quede cierto stock por vender o comprar, tu publicación se dará por caducada y desaparecerá del panel de publicaciones vigentes. Por tal razón, si tu publicación admite compra parcial, deberás tener el recaudo de habilitar una buena cantidad de citas posibles."
					},
					{
						"tipo": "p",
						"texto": "Las capsulas (cerradas o abiertas) de publicaciones que permitan aceptación parcial mostrarán la cantidad y el importe total en tipografía de color amarillo, para distinguirlas de las publicaciones comunes, que se seguirán mostrando con números blancos. Y, al abrir la capsula, podrá verse cuál es la cantidad parcial mínima que se puede aceptar."
					},
					{
						"tipo": "p",
						"texto": "La opción de aceptación parcial sólo estará habilitada para publicaciones que contengan un solo lote. Si se trata de una publicación de venta que contiene dos lotes diferentes, sólo podrá comprarse la cantidad total."
					}
				]
			},
			{
				"id": "5-10",
				"numero": "5.10",
				"titulo": "¿Puedo modificar mi publicación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Durante la vigencia podés cambiar precio, cantidad o citas posibles."
					},
					{
						"tipo": "p",
						"texto": "Para hacerlo, primero debés pausar la publicación y luego editarla."
					},
					{
						"tipo": "p",
						"texto": "Si querés cambiar otras condiciones (denominación, versión o estado), debés eliminarla y crear una nueva."
					}
				]
			},
			{
				"id": "5-11",
				"numero": "5.11",
				"titulo": "¿Puedo eliminar mi publicación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Podés eliminarla en cualquier momento mientras esté vigente, sin que ello se considere un incumplimiento."
					}
				]
			},
			{
				"id": "5-12",
				"numero": "5.12",
				"titulo": "¿Qué significa el sello “Operación garantizada”?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "El sello aparece cuando un usuario decide depositar previamente en la Oficina las divisas o pesos de su publicación."
					},
					{
						"tipo": "p",
						"texto": "El Administrador verifica su integridad y los conserva hasta que la operación sea aceptada."
					},
					{
						"tipo": "p",
						"texto": "Ventajas:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Aumenta la probabilidad de confirmación de la publicación."
							},
							{
								"texto": "Permite que el usuario que dejó su parte depositada no deba presentarse en la cita original, pudiendo coordinar luego con el Administrador."
							},
							{
								"texto": "Si la operación no se concreta, los fondos se devuelven inmediatamente al usuario que los depositó."
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "s6",
		"numero": "6",
		"titulo": "Comisiones y facturación. ¿Qué costo tiene cambiapp?",
		"intro": [
			{
				"tipo": "p",
				"texto": "La registración, ingreso y utilización de la plataforma son totalmente gratuitos."
			},
			{
				"tipo": "p",
				"texto": "Los precios que se muestran en las publicaciones tanto propias como las efectuadas por otros usuarios, que se visualizan en tu propio panel de compras o de ventas, son siempre finales. Esto significa que, considerando el precio unitario y total que aparece en las publicaciones u operaciones confirmadas, al concretarse la operación no se te requerirá ningún pago extra sobre dicho precio (si estas comprando), ni se te aplicará descuento alguno sobre dicho precio (si estas vendiendo)."
			},
			{
				"tipo": "p",
				"texto": "Técnicamente, la comisión que Cambiapp percibe por el servicio queda a cargo del usuario que acepta la publicación, y ya se encuentra incluida en el precio que ve al momento de aceptar. Por lo tanto, dicha comisión quedará automáticamente cancelada al momento de concretarse la operación en la Oficina, y el comprobante fiscal correspondiente será remitido al aceptante vía correo electrónico, a su dirección declarada."
			},
			{
				"tipo": "p",
				"texto": "La comisión podrá variar, siendo menor cuanto mayor sea el importe total de la operación confirmada, y no excederá en ningún caso del 2% más IVA sobre dicha base."
			}
		],
		"preguntas": []
	},
	{
		"id": "s7",
		"numero": "7",
		"titulo": "Seguridad y confidencialidad",
		"intro": [],
		"preguntas": [
			{
				"id": "7-1",
				"numero": "7.1",
				"titulo": "¿Mis datos personales y mis operaciones son confidenciales?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. En cambiapp la confidencialidad de tus datos personales y de tus operaciones está garantizada."
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Tu nombre real nunca se muestra a otros usuarios. Cada vez que publicás o aceptás una publicación, el sistema te asigna un alias aleatorio, visible solo en esa operación."
							},
							{
								"texto": "Con cada nueva publicación, se genera un alias distinto, asegurando que tu identidad no quede expuesta."
							},
							{
								"texto": "Al concretarse la operación, el contacto entre usuarios se evita: el Administrador es quien recibe y entrega las divisas y pesos a cada parte."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "La única excepción se da en caso de incumplimiento: si un usuario no cumple con una operación confirmada, y la contraparte lo solicita, el Administrador podrá facilitar sus datos personales y de contacto."
					},
					{
						"tipo": "p",
						"texto": "Además, cambiapp asegura que el tratamiento de los datos personales se realiza de conformidad con la normativa de protección de datos vigente en la República Argentina (Ley 25.326 y disposiciones complementarias), brindando un marco de legalidad y seguridad a toda la comunidad."
					},
					{
						"tipo": "p",
						"texto": "En cambiapp podés sentirte seguro: tus datos están protegidos, tu identidad preservada y cada operación supervisada por el Administrador."
					},
					{
						"tipo": "p",
						"texto": "La combinación de confidencialidad digital y control presencial de billetes en la Oficina asegura que formes parte de una comunidad confiable, donde operar es simple y transparente."
					}
				]
			},
			{
				"id": "7-2",
				"numero": "7.2",
				"titulo": "¿Puedo autorizar a otra persona a concretar la operación en la Oficina, en mi representación?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Podés autorizar a un tercero para que concurra en tu lugar a la Oficina. Para ello deberás:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Notificar previamente al Administrador, por correo electrónico o WhatsApp, indicando nombre completo y DNI de la persona autorizada."
							},
							{
								"texto": "El representante deberá identificarse en la Oficina, mostrando su DNI y la cápsula correspondiente a la operación confirmada."
							},
							{
								"texto": "El Administrador podrá solicitar información adicional para verificar la validez de la representación."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "De esta manera, la operación podrá concretarse aun cuando no puedas asistir personalmente."
					}
				]
			}
		]
	},
	{
		"id": "s8",
		"numero": "8",
		"titulo": "Responsabilidad e incumplimientos. Sistema de reputación",
		"intro": [],
		"preguntas": [
			{
				"id": "8-1",
				"numero": "8.1",
				"titulo": "¿Quién se hace responsable por el incumplimiento de una operación confirmada?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La responsabilidad de cumplir en tiempo y forma con una operación confirmada es exclusiva de los usuarios que la acordaron."
					},
					{
						"tipo": "p",
						"texto": "El Administrador se limita a:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Garantizar el funcionamiento de la plataforma."
							},
							{
								"texto": "Brindar el espacio físico en la Oficina."
							},
							{
								"texto": "Controlar autenticidad e integridad de los billetes."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "En caso de incumplimiento, el Administrador podrá intervenir para informar a la contraparte, intermediar en la renegociación y determinar la gravedad de la falta."
					}
				]
			},
			{
				"id": "8-2",
				"numero": "8.2",
				"titulo": "¿Qué debo hacer si no puedo cumplir con una operación confirmada?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Si no podés cumplir en tiempo o forma, tenés la obligación de:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Avisar al sistema con antelación mínima de 30 minutos, mediante las opciones “SOLICITAR CAMBIOS” o “ABORTAR”."
							},
							{
								"texto": "Si no pudieras hacerlo desde el sistema, deberás notificar al Administrador (teléfono, WhatsApp o en persona)."
							},
							{
								"texto": "Explicar las causas de la situación y, de ser posible, renegociar la operación con la contraparte."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "El incumplimiento quedará registrado en tu reputación."
					}
				]
			},
			{
				"id": "8-3",
				"numero": "8.3",
				"titulo": "¿Puedo solicitar cambios sobre una operación que ya confirmé?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí, de manera excepcional."
					},
					{
						"tipo": "p",
						"texto": "Podés solicitar cambios en las condiciones de una operación ya confirmada (cantidad, denominación, estado, precio o cita)."
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Para ello usás el botón “SOLICITAR CAMBIOS”."
							},
							{
								"texto": "La operación quedará en estado de espera hasta que el Administrador contacte a la contraparte."
							},
							{
								"texto": "Si se llega a un acuerdo, el Administrador actualizará las condiciones en el sistema."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "Recordá que solicitar cambios igualmente se registra como incumplimiento, aunque pueda resolverse."
					}
				]
			},
			{
				"id": "8-4",
				"numero": "8.4",
				"titulo": "¿Qué pasa si solicito cambios y mi contraparte no los acepta?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Si no hay acuerdo, la operación se dará por abortada, quedando registrada como incumplimiento grave del usuario que solicitó los cambios."
					}
				]
			},
			{
				"id": "8-5",
				"numero": "8.5",
				"titulo": "¿Puedo abortar una operación confirmada?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Sí. Podés abortarla seleccionando el botón “ABORTAR” en tu cápsula."
					},
					{
						"tipo": "p",
						"texto": "Sin embargo, esto constituye un incumplimiento grave, que impactará en tu reputación y puede derivar en suspensión o expulsión."
					}
				]
			},
			{
				"id": "8-6",
				"numero": "8.6",
				"titulo": "¿Qué pasa si surge un desacuerdo imprevisto en la Oficina?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "Si durante la concreción en la Oficina las partes discrepan (ej. estado de los billetes), el Administrador intermediará para:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Validar si se cumple lo acordado."
							},
							{
								"texto": "Facilitar ajustes razonables en la operación."
							},
							{
								"texto": "Determinar quién incumplió en caso de que no se logre un acuerdo."
							}
						]
					}
				]
			},
			{
				"id": "8-7",
				"numero": "8.7",
				"titulo": "¿Qué sanciones se aplican por incumplimiento?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "El Administrador podrá aplicar:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Suspensión temporal, mientras se analiza la situación."
							},
							{
								"texto": "Revelación de identidad y contacto a la contraparte cumplidora."
							},
							{
								"texto": "Registro del incumplimiento como leve o grave."
							},
							{
								"texto": "Expulsión definitiva de la comunidad en casos injustificados."
							}
						]
					}
				]
			},
			{
				"id": "8-8",
				"numero": "8.8",
				"titulo": "¿Cuándo un incumplimiento se considera justificado o injustificado?",
				"bloques": [
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Justificado: cuando se demuestra una causa razonable y verificable (ej. enfermedad, accidente, restricciones de circulación, fuerza mayor)."
							},
							{
								"texto": "Injustificado: cuando no existe causa suficiente o comprobable."
							}
						]
					}
				]
			},
			{
				"id": "8-9",
				"numero": "8.9",
				"titulo": "¿Cuándo un incumplimiento se considera grave o leve?",
				"bloques": [
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Grave: cuando la operación no se concreta, o se realiza con cambios perjudiciales para la contraparte (ej. gran diferencia de cantidad, billetes en peor estado, modificación de la cita superior a 4 horas, precio distinto al acordado)."
							},
							{
								"texto": "Leve: cuando la operación igualmente se concreta y el perjuicio es mínimo o inexistente."
							}
						]
					}
				]
			},
			{
				"id": "8-10",
				"numero": "8.10",
				"titulo": "¿Puedo calificar a otros usuarios?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "No. La reputación no se forma con calificaciones entre usuarios, sino con la evaluación del Administrador y los antecedentes operativos registrados en el sistema."
					}
				]
			},
			{
				"id": "8-11",
				"numero": "8.11",
				"titulo": "¿Cómo se determina la reputación de un usuario?",
				"bloques": [
					{
						"tipo": "p",
						"texto": "La reputación se construye a partir de:"
					},
					{
						"tipo": "ul",
						"items": [
							{
								"texto": "Antigüedad en la plataforma."
							},
							{
								"texto": "Cantidad de operaciones concretadas."
							},
							{
								"texto": "Historial de incumplimientos leves o graves."
							},
							{
								"texto": "Estatus operativo (activo, suspendido, expulsado)."
							}
						]
					},
					{
						"tipo": "p",
						"texto": "La reputación se muestra en las publicaciones vigentes antes de ser aceptadas."
					}
				]
			}
		]
	}
];
